import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.5 6.007a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6M3.751 20.112a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695 18.7 18.7 0 0 1-7.812 1.7c-2.786 0-5.433-.609-7.812-1.7a.75.75 0 0 1-.437-.695m1.526-.464A17.2 17.2 0 0 0 12 21.007c2.387 0 4.658-.484 6.723-1.359a6.75 6.75 0 0 0-13.446 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }